import './about.css';

function About() {
    return(
        
        <section className="about-page">
        <h1>Sobre nosotros</h1>

        <section className="about-section">
            <p>
            <strong>ExDev</strong> es el Club de Desarrollo Experimental de la UTEM, un espacio creado por estudiantes y para estudiantes, donde la innovación, la tecnología y el hacer por gusto se unen para construir ideas reales.
            No somos una asignatura, ni un trabajo: somos un equipo multidisciplinario que transforma la curiosidad y la motivación en proyectos concretos.
            </p>
            <p>
            Nuestro origen se remonta al año 2021, cuando se fusionaron dos iniciativas emblemáticas: el Club de Desarrollo de Videojuegos (GameDev) y el Club de Innovación y Desarrollo (INNDEV).
            Desde entonces, seguimos el legado de ambos grupos con un enfoque claro: fomentar el aprendizaje activo y crear productos funcionales con impacto dentro y fuera de la universidad.
            </p>
            <p>
            En ExDev creemos que la universidad debe ser más que teoría. Por eso, cada uno de nuestros proyectos representa una oportunidad para aplicar conocimientos reales, colaborar con otros estudiantes y crear cosas que puedas ver, tocar y decir con orgullo: “esto lo hicimos nosotros”.
            </p>
        </section>

        <section className="about-section">
            <h2>Nuestra cultura</h2>
            <p>
            En ExDev, la cultura es tan importante como los proyectos. Nos definimos por ser un equipo diverso, horizontal y buena onda.
            Somos apasionados por lo que hacemos, pero también valoramos el humor, el respeto mutuo y el aprendizaje colectivo.
            Cada miembro elige un emoji que lo representa, y celebramos tanto los avances técnicos como los memes del día.
            </p>
            <p>
            Compartimos espacios físicos (sí, nuestras queridas salas en Macul) que no solo usamos para trabajar, sino también para descansar, compartir y pasarlo bien entre clases.
            No somos formales, pero sí organizados: contamos con roles claros, reuniones quincenales llamadas <strong>Twicelys</strong>, y actividades que van desde talleres hasta salidas recreativas.
            </p>
        </section>

        <section className="about-section">
            <h2>Nuestra filosofía: cultura maker</h2>
            <p>
            Nos mueve la <strong>cultura maker</strong>, la idea de que cualquiera puede aprender a construir algo sin esperar a ser experto.
            En ExDev combinamos electrónica, programación, diseño 3D, carpintería, arte, IA y más, porque creemos que el conocimiento se vuelve poderoso cuando se mezcla, se aplica y se comparte.
            </p>
        </section>

        <section className="about-section">
            <h2>Cómo funcionamos</h2>
            <p>
            Aunque no existe un protocolo formal para los clubes universitarios, para nosotros ser un club significa trabajar juntos por una meta común.
            Aquí no se trata de cumplir horarios, sino de comprometerse con el equipo, con los proyectos y con lo que cada uno quiera aprender.
            No es un lugar para hacer nada, pero tampoco se exige ser perfecto: solo tener ganas y aportar.
            </p>
            <p>
            Nuestro equipo se organiza con roles como líder, encargados administrativos, comunicadores, encargados de redes sociales, finanzas, inventario e incluso IT.
            Cada uno cumple funciones clave para que el Club funcione, crezca y se mantenga activo ante la universidad y la comunidad.
            </p>
        </section>

        <section className="about-section">
            <h2>Nuestra historia</h2>
            <p><strong>ExDev nace en 2021</strong>, pero su historia comienza mucho antes:</p>
            <ul>
            <li>
                <strong>GameDev</strong>, fundado en 2015, desarrolló videojuegos, arcades y proyectos con enfoque en hardware y entretenimiento.
                Participaron en Festigame, Global Game Jam, talleres, torneos y mucho más.
            </li>
            <li>
                <strong>INNDEV</strong>, creado en 2016, se enfocó en soluciones innovadoras aplicando tecnologías como IoT, fabricación digital y plataformas educativas.
                También fue el grupo creador original de la app MiUTEM.
            </li>
            </ul>
            <p>
            Ambos clubes compartían una visión: usar el conocimiento para crear cosas útiles y entretenidas.
            Y cuando sus integrantes estaban a punto de titularse, decidieron fusionarse para no dejar que todo ese aprendizaje se perdiera.
            </p>
            <p>
            Hoy, ExDev es esa continuación: un lugar donde cualquier estudiante con ganas puede experimentar, aprender y construir algo que deje huella.
            </p>
        </section>
        </section>
    );
    
}

export default About;
